import _FaIcon from "./fa-icon.component.js";

export const FaIcon = _FaIcon;
